export interface Ingredient {
  name: string;
  category: string;
}

const ingredients: Ingredient[] = [
  /* A */
  { name: "Adukipapu", category: "Palkokasvit" },
  { name: "Ahven", category: "Kala ja äyriäiset" },
  { name: "Ananaskirsikka", category: "Hedelmät" },
  { name: "Ananas, tuore", category: "Hedelmät" },
  { name: "Ananaspalat, säilyke", category: "Hedelmäsäilykkeet" },
  { name: "Ananasrenkaat, säilyke", category: "Hedelmäsäilykkeet" },
  { name: "Ananas tuore", category: "Hedelmät" },
  { name: "Anjovis", category: "Kala ja äyriäiset" },
  { name: "Appelsiini", category: "Hedelmät" },
  { name: "Aprikoosi", category: "Hedelmät" },
  { name: "Artisokka", category: "Vihannekset" },
  { name: "Auringonkukansiemen", category: "Pähkinät ja siemenet" },
  { name: "Auringonkukkaöljy", category: "Öljyt ja rasvat" },
  { name: "Aurinkokuivattu tomaatti", category: "Vihannekset" },
  { name: "Avokado", category: "Hedelmät" },

  /* B */
  { name: "Banaani", category: "Hedelmät" },
  { name: "Basilika, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Basilika, tuore", category: "Yrtit ja mausteet" },
  { name: "Bataatti", category: "Juurekset" },
  { name: "Broileri", category: "Liha ja siipikarja" },

  /* C */
  { name: "Cashewpähkinä", category: "Pähkinät ja siemenet" },
  { name: "Cayennepippuri, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Cayennepippuri, tuore", category: "Yrtit ja mausteet" },
  { name: "Cheddar", category: "Juustot" },
  { name: "Chiansiemen", category: "Pähkinät ja siemenet" },
  { name: "Chili", category: "Yrtit ja mausteet" },
  { name: "Chili, punainen", category: "Yrtit ja mausteet" },
  { name: "Chilirouhe", category: "Yrtit ja mausteet" },
  { name: "Chilikastike", category: "Mausteet ja kastikkeet" },
  { name: "Chorizo", category: "Makkarat" },
  { name: "Curryjauhe", category: "Yrtit ja mausteet" },

  /* D */

  /* E */
  { name: "Edamjuusto", category: "Juustot" },
  { name: "Emmentaljuusto", category: "Juustot" },
  { name: "Etana", category: "Kala ja äyriäiset" },
  /* F */
  { name: "Fenkoli", category: "Kasvikset" },
  { name: "Feta", category: "Juustot" },
  { name: "Fileepihvi", category: "Liha ja siipikarja" },
  { name: "Fruktoosi, hedelmäsokeri", category: "Sokerit ja siirapit" },

  /* G */
  { name: "Granaattiomena", category: "Hedelmät" },
  { name: "Greippi", category: "Hedelmät" },
  { name: "Grillijuusto", category: "Juustot" },
  { name: "Grillimakkara", category: "Makkarat" },
  { name: "Guacamole", category: "Naposteltavat" },
  { name: "Guava", category: "Hedelmät" },

  /* H */
  { name: "Haaparousku", category: "Sienet" },
  { name: "Halloumijuusto", category: "Juustot" },
  { name: "Hampunsiemen", category: "Pähkinät ja siemenet" },
  { name: "Hapanimeläkastike", category: "Maustekastikkeet" },
  { name: "Hapankaali", category: "Säilykeet" },
  { name: "Hapankorppu", category: "Leivät ja leivoinnaiset" },
  { name: "Hasselpähkinä", category: "Pähkinät ja siemenet" },
  { name: "Hauki", category: "Kala ja äyriäiset" },
  { name: "Herkkusieni", category: "Sienet" },
  { name: "Herkkusieni, jumbo", category: "Sienet" },
  { name: "Herkkutatti", category: "Sienet" },
  { name: "Herneet, kuivattu", category: "Palkokasvit" },
  { name: "Herneet, tuore", category: "Palkokasvit" },
  { name: "Herneet, pakaste", category: "Palkokasvit" },
  { name: "Hiiva", category: "Leivonta ja makeiset" },
  { name: "Hirvenliha", category: "Liha ja siipikarja" },
  { name: "Hummeri", category: "Kala ja äyriäiset" },
  { name: "Hunaja", category: "Makeutusaineet" },
  { name: "Hunajameloni", category: "Hedelmät" },
  { name: "Härkäpapu", category: "Palkokasvit" },
  { name: "Härkäpapurouhe", category: "Kasvisproteiinit" },

  /* I */
  { name: "Inkivääri, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Inkivääri, tuore", category: "Yrtit ja mausteet" },

  /* J */
  { name: "Jauheliha, kana", category: "Liha ja siipikarja" },
  { name: "Jauheliha, nauta", category: "Liha ja siipikarja" },
  { name: "Jauheliha, possu", category: "Liha ja siipikarja" },
  { name: "Jauheliha, sika-nauta", category: "Liha ja siipikarja" },
  { name: "Jauho, erikoisvehnäjauho", category: "Jauhot" },
  { name: "Jauho, graham", category: "Jauhot" },
  { name: "Jauho, hiivaleipä", category: "Jauhot" },
  { name: "Jauho, hirssi", category: "Jauhot" },
  { name: "Jauho, kaura", category: "Jauhot" },
  { name: "Jauho, korppu", category: "Jauhot" },
  { name: "Jauho, maissi", category: "Jauhot" },
  { name: "Jauho, maissitärkkelys", category: "Jauhot" },
  { name: "Jauho, ohra", category: "Jauhot" },
  { name: "Jauho, peruna", category: "Jauhot" },
  { name: "Jauho, riisi", category: "Jauhot" },
  { name: "Jauho, ruis", category: "Jauhot" },
  { name: "Jauho, soija", category: "Jauhot" },
  { name: "Jauho, speltti", category: "Jauhot" },
  { name: "Jauho, tapioka", category: "Jauhot" },
  { name: "Jauho, tattari", category: "Jauhot" },
  { name: "Jauho, täysjyväohra", category: "Jauhot" },
  { name: "Jauho, täysjyväriisi", category: "Jauhot" },
  { name: "Jauho, täysjyväruis", category: "Jauhot" },
  { name: "Jauho, täysjyvävehnä", category: "Jauhot" },
  { name: "Jauho, vehnä", category: "Jauhot" },
  { name: "Jugurtti, maustamaton", category: "Jugurtit" },
  { name: "Jugurtti, kreikkalainen", category: "Jugurtit" },
  { name: "Jugurtti, turkkilainen", category: "Jugurtit" },
  { name: "Juolukka", category: "Marjat" },
  { name: "Juuriselleri", category: "Kasvikset" },
  { name: "Juustodippi", category: "Naposteltavat" },
  { name: "Juustoraaste", category: "juustot" },
  { name: "Jääsalaatti", category: "Kasvikset" },
  { name: "Jäätelö", category: "Leivonta ja makeiset" },

  /* K */
  { name: "Kaakaojauhe", category: "Leivonta ja makeiset" },
  { name: "Kaali", category: "Vihannekset" },
  { name: "Kalaliemikuutio", category: "Sekalaiset ruoka-aineet" },
  { name: "Kalkkuna", category: "Liha ja siipikarja" },
  { name: "Kalkkunan rintafilee", category: "Liha ja siipikarja" },
  { name: "Kampela", category: "Kala ja äyriäiset" },
  { name: "Kana", category: "Liha ja siipikarja" },
  { name: "Kanafilee", category: "Liha ja siipikarja" },
  { name: "Kanaliemikuutio", category: "Sekalaiset ruoka-aineet" },
  { name: "Kanankoipi", category: "Liha ja siipikarja" },
  { name: "Kananmuna", category: "Munat ja maitotuotteet" },
  { name: "Kanansiipi, tulinen", category: "Munat ja maitotuotteet" },
  { name: "Kangasrousku", category: "Sienet" },
  { name: "Kanttarelli", category: "Sienet" },
  { name: "Kapris", category: "Kasvissäilykkeet" },
  { name: "Karpalo, kuivattu", category: "Marjat" },
  { name: "Karpalo, tuore", category: "Marjat" },
  { name: "Karvarousku", category: "Sienet" },
  { name: "Karviainen", category: "Marjat" },
  { name: "Kassler", category: "Liha ja siipikarja" },
  { name: "Kastanja", category: "Pähkinät ja siemenet" },
  { name: "Kassler", category: "Liha ja siipikarja" },
  { name: "Kasvisliemikuutio", category: "Sekalaiset ruoka-aineet" },
  { name: "Katajanmarja", category: "Marjat" },
  { name: "Katkarapu", category: "Kala ja äyriäiset" },
  { name: "Kaurahiutale", category: "Viljatuotteet" },
  { name: "Kaurajauho", category: "Viljatuotteet" },
  { name: "Kaviaari", category: "Kala ja äyriäiset" },
  { name: "Keltajuuri", category: "Juurekset" },
  { name: "Kerma", category: "Maitotuotteet" },
  { name: "Kermajuusto", category: "Juustot" },
  { name: "Kermaviili", category: "Maitotuotteet" },
  { name: "Kesäkurpitsa", category: "Kasvikset" },
  { name: "Ketsuppi", category: "Kastikkeet ja mausteet" },
  { name: "Kiinankaali", category: "Kasvikset" },
  { name: "Kiivi", category: "Hedelmät" },
  { name: "Kidneypavut, kuivatut", category: "Palkokasvit" },
  { name: "Kidneypavut, suolaliemiemessä", category: "Palkokasvit" },
  { name: "Kikherne, kuivatut", category: "Palkokasvit" },
  { name: "Kikherne, suolaliemessä", category: "Palkokasvit" },
  { name: "Kinkku", category: "Liha ja siipikarja" },
  { name: "Kirjolohi", category: "Kala ja äyriäiset" },
  { name: "Kirjolohi, kylmäsavustettu", category: "Kala ja äyriäiset" },
  { name: "Kirjolohi, lämminsavustettu", category: "Kala ja äyriäiset" },
  { name: "Kirsikka", category: "Hedelmät" },
  { name: "Kirsikkatomaatti", category: "Vihannekset" },
  { name: "Konjakki", category: "Kastikkeet ja mausteet" },
  { name: "Kookoshiutale", category: "Pähkinät ja siemenet" },
  { name: "Kookosmaito", category: "Kasvismehut" },
  { name: "Korianteri, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Korianteri, tuore", category: "Yrtit ja mausteet" },
  { name: "Kuha", category: "Kala ja äyriäiset" },
  { name: "Kuivahiiva", category: "Leivonta ja makeiset" },
  { name: "Kukkakaali", category: "Kasvikset" },
  { name: "Kuohukerma", category: "Maitotuotteet" },
  { name: "Kurkku", category: "Vihannekset" },
  { name: "Kurpitsa", category: "Kasvikset" },
  { name: "Kurpitsansiemen", category: "Pähkinät ja siemenet" },
  { name: "Kurkuma", category: "Yrtit ja mausteet" },
  { name: "Kyssäkaali", category: "Kasvikset" },

  /* L */
  { name: "Laakerinlehti, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Laakerinlehti, tuore", category: "Kala ja äyriäiset" },
  { name: "Lahna", category: "Yrtit ja mausteet" },
  { name: "Lakka, pakaste", category: "Marjat" },
  { name: "Lakka, tuore", category: "Marjat" },
  { name: "Lanttu", category: "Juurekset" },
  { name: "Latva-artisokka", category: "Kasvikset" },
  { name: "Lehtikaali", category: "Kasvikset" },
  { name: "Lehtiselleri", category: "Kasvikset" },
  { name: "Leivinjauhe", category: "Sekalaiset ruoka-aineet" },
  { name: "Lenkkimakkara", category: "Makkarat" },
  { name: "Leipäjuusto", category: "Juustot" },
  { name: "Liivate", category: "Sekalaiset ruoka-aineet" },
  { name: "Lime", category: "Hedelmät" },
  { name: "Linssit, kuivatut", category: "Palkokasvit" },
  { name: "Linssit, suolaliemessä", category: "Palkokasvit" },
  { name: "Lohi", category: "Kala ja äyriäiset" },
  { name: "Lohi, graavattu", category: "Kala ja äyriäiset" },
  { name: "Luumu", category: "Hedelmät" },

  /* M */
  { name: "Maa-artisokka", category: "Kasvikset" },
  { name: "Maapähkinä", category: "Pähkinät ja siemenet" },
  { name: "Maapähkinävoi", category: "Levitteet" },
  { name: "Maapähkinäöljy", category: "Öljyt ja rasvat" },
  { name: "Made", category: "Kala ja äyriäiset" },
  { name: "Majoneesi", category: "Kastikkeet ja mausteet" },
  { name: "Makkara", category: "Makkarat" },
  { name: "Maissi", category: "Kasvikset" },
  { name: "Maissijauho", category: "Viljatuotteet" },
  { name: "Maissilastut", category: "Naposteltavat" },
  { name: "Maissiöljy", category: "Ölyt ja rasvat" },
  { name: "Maito", category: "Maitotuotteet" },
  { name: "Makea chilikastike", category: "Kastikkeet" },
  { name: "Makrilli", category: "Kala ja äyriäiset" },
  { name: "Maksa, broileri", category: "Sisäelin" },
  { name: "Maksa, nauta", category: "Sisäelin" },
  { name: "Maksa, poro", category: "Sisäelin" },
  { name: "Maksa, possu", category: "Sisäelin" },
  { name: "Maksamakkara", category: "Levitteet" },
  { name: "Mandariini", category: "Hedelmät" },
  { name: "Mango", category: "Hedelmät" },
  { name: "Mangoldi", category: "Hedelmät" },
  { name: "Mannasuurimo", category: "Jauhot" },
  { name: "Mansikka", category: "marjat" },
  { name: "Manteli", category: "Pähkinät ja siemenet" },
  { name: "Margariini", category: "Öljyt ja rasvat" },
  { name: "Marja-aronia", category: "marjat" },
  { name: "Maustekurkku", category: "Säilykkeet" },
  { name: "Maustepippuri", category: "Yrtit ja mausteet" },
  { name: "Meetvursti", category: "Leikkeleet" },
  { name: "Merilevä", category: "kasvissäilykkeet" },
  { name: "Merisuola", category: "Yrtit ja mausteet" },
  { name: "Minttu, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Minttu, tuore", category: "Yrtit ja mausteet" },
  { name: "Muikku", category: "Kala ja äyriäiset" },
  { name: "Munakoiso", category: "Vihannekset" },
  { name: "Munuainen", category: "Sisäelin" },
  { name: "Mustaherukka", category: "Marjat" },
  { name: "Mustajuuri", category: "Kasvikset" },
  { name: "Mustaleimajuusto", category: "juustot" },
  { name: "Mustapapu", category: "Palkokasvit" },
  { name: "Mustapapu, suolaliemessä", category: "Palkokasvit" },

  { name: "Mustapippuri", category: "Yrtit ja mausteet" },
  { name: "Mustatorvisieni, kuivattu", category: "Sienet" },
  { name: "Mustatorvisieni, tuore", category: "Sienet" },
  { name: "Mustikka, kuivattu", category: "Marjat" },
  { name: "Mustikka, pakaste", category: "Marjat" },
  { name: "Mustikka, tuore", category: "Marjat" },
  { name: "Myskikurpitsa", category: "Vihannekset" },
  { name: "Mäti", category: "Kala ja äyriäiset" },

  /* N */
  { name: "Nahkiainen", category: "Kala ja äyriäiset" },
  { name: "Nakki", category: "Makkarat" },
  { name: "Naudanliha", category: "Liha ja siipikarja" },
  { name: "Naudan sisäfilee", category: "Liha ja siipikarja" },
  { name: "Naudan ulkofilee", category: "Liha ja siipikarja" },
  { name: "Naudankylki", category: "Liha ja siipikarja" },
  { name: "Naudanpaisti", category: "Liha ja siipikarja" },
  { name: "Naudanpotka", category: "Liha ja siipikarja" },
  { name: "Naudanrinta", category: "Liha ja siipikarja" },
  { name: "Nauris", category: "Kasvikset" },
  { name: "Nokkonen", category: "Kasvikset" },
  { name: "Nuudelit", category: "Viljatuotteet" },
  { name: "Nuudelit, kokojyvä", category: "Viljatuotteet" },

  /* O */
  { name: "Oliivi", category: "Kasvissäilykkeet" },
  { name: "Oliivi, kalamata", category: "Kasvissäilykkeet" },
  { name: "Oliivi, kalamata", category: "Kasvissäilykkeet" },
  { name: "Oliivi, vihreä", category: "Kasvissäilykkeet" },
  { name: "Oliiviöljy", category: "Öljyt ja rasvat" },
  { name: "Omena", category: "Hedelmät" },
  { name: "Omenaviinietikka", category: "Etikat" },
  { name: "Oregano, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Oregano, tuore", category: "Yrtit ja mausteet" },
  { name: "Osteri", category: "Kala ja äyriäiset" },

  /* P */
  { name: "Paahtoleipä", category: "Leivät ja leivoinnaiset" },
  { name: "Palsternakka", category: "Kasvikset" },
  { name: "Papaija", category: "Hedelmät" },
  { name: "Paprika, jauhettu", category: "Yrtit ja mausteet" },
  { name: "Paprika, keltainen", category: "Vihannekset" },
  { name: "Paprika, punainen", category: "Vihannekset" },
  { name: "Paprika, tuore", category: "Vihannekset" },
  { name: "Parmesaani", category: "juustot" },
  { name: "Pasta", category: "Viljatuotteet" },
  { name: "Pasta, fusilli", category: "Viljatuotteet" },
  { name: "Pasta, kokojyvä", category: "Viljatuotteet" },
  { name: "Pasta, makaroni", category: "Viljatuotteet" },
  { name: "Pasta, penne", category: "Viljatuotteet" },
  { name: "Pasta, spagetti", category: "Viljatuotteet" },
  { name: "Pasta, tagliatelle", category: "Viljatuotteet" },
  { name: "Parapähkinä", category: "Pähkinät ja siemenet" },
  { name: "Parsa", category: "Kasvikset" },
  { name: "Parsakaali", category: "Kasvikset" },
  { name: "Passionhedelmä", category: "Hedelmät" },
  { name: "Pekoni", category: "Liha ja siipikarja" },
  { name: "Pellavansiemen", category: "Pähkinät ja siemenet" },
  { name: "Pellavaöljy", category: "Öljyt ja rasvat" },
  { name: "Persikka", category: "Hedelmät" },
  { name: "Persilja", category: "Yrtit ja mausteet" },
  { name: "Persilja, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Persilja, tuore", category: "Yrtit ja mausteet" },
  { name: "Peruna", category: "Juurekset" },
  { name: "Perunalastu", category: "Naposteltavat" },
  { name: "Perunasipulisekoitus, pakaste", category: "Pakasteet" },
  { name: "Pihlajanmarja", category: "Marjat" },
  { name: "Piimä", category: "Maitotuotteet" },
  { name: "Pinaatti, baby", category: "Yrtit ja mausteet" },
  { name: "Pinaatti, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Pinaatti, pakaste", category: "Yrtit ja mausteet" },
  { name: "Pinaatti, tuore", category: "Yrtit ja mausteet" },
  { name: "Pinjansiemen", category: "Pähkinät ja siemenet" },
  { name: "Piparjuuri", category: "Kasvikset" },
  { name: "Pistaasipähkinä", category: "Pähkinät ja siemenet" },
  { name: "Porkkana", category: "Juurekset" },
  { name: "Poronliha", category: "Riista" },
  { name: "Porsaan sisäfilee", category: "Liha ja siipikarja" },
  { name: "Porsaan ulkofilee", category: "Liha ja siipikarja" },
  { name: "Punaiset linssit, kuivatut", category: "Palkokasvit" },
  { name: "Punaiset linssit, suolaliemessä", category: "Palkokasvit" },
  { name: "Punaherukka", category: "Marjat" },
  { name: "Punajuuri", category: "Juurekset" },
  { name: "Punajuuri, esikeitetty", category: "Juurekset" },
  { name: "Punakaali", category: "Kasvikset" },
  { name: "Punasipuli", category: "Vihannekset" },
  { name: "Punaviinietikka", category: "Etikat" },
  { name: "Puolukka, pakaste", category: "Marjat" },
  { name: "Puolukka, tuore", category: "Marjat" },
  { name: "Purjosipuli", category: "Kasvikset" },
  { name: "Päärynä", category: "Hedelmät" },

  /* Q */
  { name: "Quinoa", category: "Viljatuotteet" },

  /* R */
  { name: "Raejuusto", category: "Juustot" },
  { name: "Rahka", category: "Maitotuotteet" },
  { name: "Ranskanperuna, pakaste", category: "perunapakasteet" },
  { name: "Raitajuuri", category: "Juurekset" },
  { name: "Ranskanleipä", category: "Leivät ja leivoinnaiset" },
  { name: "Ranskankerma", category: "Munat ja maitotuotteet" },
  { name: "Raparperi", category: "Kasvikset" },
  { name: "Rapu", category: "Kala ja äyriäiset" },
  { name: "Retiisi", category: "Kasvikset" },
  { name: "Riisi", category: "Viljatuotteet" },
  { name: "Riisikakku", category: "Viljatuotteet" },
  { name: "Riisi, tumma", category: "Viljatuotteet" },
  { name: "Risottoriisi", category: "Viljatuotteet" },
  { name: "Roomansalaatti", category: "Kasvikset" },
  { name: "Rosmariini, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Rosmariini, tuore", category: "Yrtit ja mausteet" },
  { name: "Ruisleipä", category: "Leivät ja leivonnaiset" },
  { name: "Rucola", category: "Kasvikset" },
  { name: "Ruohosipuli", category: "Yrtit ja mausteet" },
  { name: "Ruokakerma", category: "Maitotuotteet" },
  { name: "Ruokasooda", category: "Sekalaiset ruoka-aineet" },
  { name: "Rusina", category: "Kuivatut hedelmät" },
  { name: "Ruusukaali", category: "Kasvikset" },
  { name: "Ruusunmarja", category: "Marjat" },
  { name: "Rypsiöljy", category: "Öljyt ja rasvat" },
  { name: "Ryynimakkara", category: "Makkarat" },

  /* S */
  { name: "Salaattijuusto", category: "juustot" },
  { name: "Salaattisekoitus", category: "Vihannekset" },
  { name: "Salsadippi", category: "Kastikkeet ja mausteet" },
  { name: "Sardiini", category: "Kala ja äyriäiset" },
  { name: "Savupaprikajauhe", category: "Yrtit ja mausteet" },
  { name: "Savutofu", category: "Kasviproteiinit" },
  { name: "Seesaminsiemenet", category: "Pähkinät ja siemenet" },
  { name: "Seiti, pakaste", category: "Kala ja äyriäiset" },
  { name: "Siika", category: "Kala ja äyriäiset" },
  { name: "Siirappi", category: "Sokerit ja siirapit" },
  { name: "Siitakesieni", category: "Sienet" },
  { name: "Silakka", category: "Kala ja äyriäiset" },
  { name: "Silli, säilyke", category: "Kala ja äyriäiset" },
  { name: "Sinisimpukka", category: "Kala ja äyriäiset" },
  { name: "Sinappi, dijon", category: "Kastikkeet ja mausteet" },
  { name: "Sinappi, hunaja", category: "Kastikkeet ja mausteet" },
  { name: "Sinihomejuusto", category: "Juustot" },
  { name: "Sipuli", category: "Vihannekset" },
  { name: "Sitruuna", category: "Hedelmät" },
  { name: "Sitruunamehu", category: "Kastikkeet ja mausteet" },
  { name: "Smetana", category: "Maitotuotteet" },
  { name: "Soijakastike", category: "Maustekastikkeet" },
  { name: "Sokeri", category: "Sokerit ja siirapit" },
  { name: "Suklaa", category: "Makeiset" },
  { name: "Suklaa, maito", category: "Makeiset" },
  { name: "Suklaa, tumma", category: "Makeiset" },
  { name: "Suklaa, valko", category: "Makeiset" },
  { name: "Sulatejuusto", category: "Juustot" },
  { name: "Suola", category: "Yrtit ja mausteet" },
  { name: "Suolakurkku", category: "Säilykkeet" },
  { name: "Suolapähkinä", category: "Pähkinät ja siemenet" },
  { name: "Suppilovahvero", category: "Sienet" },
  { name: "Sriracha", category: "Maustekastikkeet" },
  { name: "Sydän, naudan", category: "Sisäelin" },
  { name: "Särki", category: "Kala ja äyriäiset" },

  /* T */
  { name: "Taateli", category: "Kuivatut hedelmät" },
  { name: "Tahini", category: "Kastikkeet ja mausteet" },
  { name: "Taimen", category: "Kala ja äyriäiset" },
  { name: "Tee", category: "Juomat" },
  { name: "Teriyakikastike", category: "Maustekastikkeet" },
  { name: "Tikka Masala, maustetahna", category: "Maustekastikkeet" },
  { name: "Tilli, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Tilli, tuore", category: "Yrtit ja mausteet" },
  { name: "Timjami", category: "Yrtit ja mausteet" },
  { name: "Timjami, kuivattu", category: "Yrtit ja mausteet" },
  { name: "Timjami, tuore", category: "Yrtit ja mausteet" },
  { name: "Tofu", category: "Palkokasvivalmisteet" },
  { name: "Tomaatti", category: "Vihannekset" },
  { name: "Tomaattimurska", category: "Säilykkeet" },
  { name: "Tomaattipyree", category: "Säilykkeet" },
  { name: "Tomaattisose", category: "Säilykkeet" },
  { name: "Tonnikala,", category: "Kala ja äyriäiset" },
  { name: "Tonnikala, säilyke", category: "Kala ja äyriäiset" },
  { name: "Tortillalettu", category: "Viljatuotteet" },
  { name: "Tuorejuusto", category: "juustot" },
  { name: "Turska", category: "Kala ja äyriäiset" },
  { name: "Tyrnimarja", category: "Marjat" },

  /* U */
  { name: "Unikonsiemen", category: "Pähkinät ja siemenet" },

  /* V */
  { name: "Vadelma", category: "Marjat" },
  { name: "Vadelma, pakaste", category: "Marjat" },
  { name: "Vadelma, tuore", category: "Marjat" },
  { name: "Valkoiset pavut, tomaattikastikkeesa", category: "Vihannekset" },
  { name: "Valkokaali", category: "Kasvikset" },
  { name: "Valkopippuri", category: "Yrtit ja mausteet" },
  { name: "Valkoretikka", category: "Kasvikset" },
  { name: "Valkosipuli", category: "Vihannekset" },
  { name: "Valkoviini", category: "Juomat" },
  { name: "Valkosipulijauhe", category: "Yrtit ja mausteet" },
  { name: "Valkoviinietikka", category: "Etikat" },
  { name: "Vanilijasokeri", category: "Sokerit" },
  { name: "Varsiselleri", category: "Kasvikset" },
  { name: "Varhaiskaali", category: "Vihannekset" },
  { name: "Vehnäjauho", category: "Viljatuotteet" },
  { name: "Verkkomeloni", category: "Hedelmät" },
  { name: "Vesikastanja", category: "Kasvikset" },
  { name: "Vesimeloni", category: "Hedelmät" },
  { name: "Vihreät pavut", category: "Vihannekset" },
  { name: "Vihreät pavut, kuivatut", category: "Vihannekset" },
  { name: "Vihreät pavut, pakaste", category: "Vihannekset" },
  { name: "Vihreät pavut, suolaliemessä", category: "Vihannekset" },
  { name: "Viikuna", category: "Hedelmät" },
  { name: "Viikuna, kuivattu", category: "Kuivatut hedelmät" },
  { name: "Viili", category: "Maitotuotteet" },
  { name: "Viinirypäle", category: "Hedelmät" },
  { name: "Viiriäisen muna", category: "Kananmunat" },
  { name: "Voi", category: "Öljyt ja rasvat" },
  { name: "Väkiviinaetikka", category: "Etikat" },
  { name: "Vispikerma", category: "Maitotuotteet" },
];

export default ingredients;
